import styled from 'styled-components';
import { Swiper } from 'swiper/react';

import { PaletteColor } from '@utils/types';

export const PriceContainer = styled.div<{ show?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 20px;
  background-color: ${({ theme }) => theme.palette.D10};
  gap: 10px;
  align-items: flex-start;
  display: ${({ show }) => (show ? 'none' : 'flex')};
  max-height: 156px;
  overflow: hidden;
  border-radius: ${({ show }) => (show ? '8px' : '8px 0 8px 8px')};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    border-radius: 0 0 8px 8px;
  }
`;
export const Wrapper = styled.div<{ borderColor: PaletteColor }>`
  height: 107px;
  width: 117px;
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 8px;
`;
export const Container = styled.div`
  display: grid;
  justify-content: center;
  text-align: center;
  height: 107px;
  width: 117px;
`;
export const Date = styled.div`
  font-size: 14px;
`;
export const Day = styled.div`
  font-size: 14px;
`;
export const DailyDiscountedButton = styled.button<{ isShow?: boolean }>`
  width: 220px;
  height: 38px;
  padding: 8px 21px;
  border: none;
  background-color: ${({ theme }) => theme.palette.D10};
  margin-top: 4px;
  border-radius: ${(props) => (props.isShow ? '8px' : '8px 8px 0 0')};
  cursor: pointer;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const StyledSwiper = styled(Swiper)`
  width: 100%;

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 20px;
    color: ${({ theme }) => theme.palette.D400};
    font-weight: bold;
  }
  .swiper-button-prev {
    left: -4px;
  }
  .swiper-button-next {
    right: 20px;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 0px;
  }
`;
